import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { InterestedSitter } from '../types/InterestedSitter';

const URL = '/v2/interested-sitters';

class InterestedSitterService {
  static getByFilter(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<InterestedSitter>> {
    return axios.get(URL, config);
  }

  static create(
    data: InterestedSitter,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<InterestedSitter>> {
    return axios.post(URL, data, config);
  }

  static patch(
    data: Partial<InterestedSitter>,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<InterestedSitter>> {
    return axios.patch(URL, data, config);
  }
}

export { InterestedSitterService };
